import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp } from '@ionic/angular/standalone';
import { Capacitor } from '@capacitor/core';
import { CookieConsentComponent } from '../cookie-consent/cookie-consent.component';
import { CookieConsentService } from '../../infrastructure/services/cookie-consent.service';
import { ToastComponent } from './toast.component';
import { IapService } from '../../infrastructure/services/iap.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, RouterOutlet, CookieConsentComponent, ToastComponent],
  template: `
    <ion-app>
      <router-outlet />
      @if (cookieConsent.needsConsent() && !isIos) {
        <app-cookie-consent />
      }
      <app-toast />
    </ion-app>
  `,
})
export class RootComponent implements OnInit {
  readonly cookieConsent = inject(CookieConsentService);
  readonly isIos = Capacitor.getPlatform() === 'ios';

  private readonly iap = inject(IapService);

  ngOnInit(): void {
    // On iOS: drain any pending /verify retries from prior sessions and
    // silently re-sync Apple entitlement (covers reinstall / new device / out-of-app renewals).
    if (this.isIos) {
      void this.iap.drainAndRestore();
    }
  }
}
